// extracted by mini-css-extract-plugin
export default {"socialIconWrap":"SocialIcons_socialIconWrap__odSeK","socialIcon":"SocialIcons_socialIcon__ZRohJ","socialIconImg":"SocialIcons_socialIconImg__Uwz9h"};